module.exports = __webpack_public_path__ + "img/img_guang.f28d772c.png";